import React, { useState } from "react";
import { alpha, IconButton, Stack } from "@mui/material";
import UsersDeleteConfirmationDialog from "../UsersDeleteConfirmationDialog";
import UsersInfoFormDialog from "../UsersInfoFormDialog";
import UsersNewPasswordFormDialog from "../UsersNewPasswordFormDialog";
import { Eye, Key, SecurityUser, Trash } from "iconsax-react";
import { blue, grey, indigo, red } from "@mui/material/colors";
import { usePermissions } from "../../../hooks/permissions/usePermissions";
import UsersPermissionsDialog from "../UsersPermissionsDialog";
import { useSelector } from "react-redux";

export default function UsersTableActions({ user, fetchUsers }) {
  const [openDialog, setOpenDialog] = useState(null);

  const { extraInformation } = useSelector((state) => state.user);
  const currentUserId = extraInformation.id_user;
  const isSuperAdmin = extraInformation?.id_role === 5;
  const isRegionalAdmin = Boolean(extraInformation?.is_zone_manager);

  const isCurrentUser = user.id === currentUserId;
  const isAdminUser = user.role === 'Administrador';
  
  const { hasAllPermissions } = usePermissions();

  const handleDialogOpen = (dialogName) => {
    setOpenDialog(dialogName);
  };

  const handleDialogClose = () => {
    setOpenDialog(null);
  };

  return (
    <Stack
      direction="row"
      spacing={0.1}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        gap: "4px",
      }}
    >
      <UsersInfoFormDialog
        open={openDialog === "UserInfo"}
        user={user}
        onClose={() => {
          handleDialogClose();
        }}
        fetchUsers={fetchUsers}
      />
      <UsersPermissionsDialog
        open={openDialog === "EditPermissions"}
        user={user}
        onClose={() => {
          handleDialogClose();
        }}
        fetchUsers={fetchUsers}
      />
      <UsersDeleteConfirmationDialog
        open={openDialog === "DeleteConfirmation"}
        user={user}
        fetchUsers={fetchUsers}
        onClose={() => {
          handleDialogClose();
        }}
      />
      <UsersNewPasswordFormDialog
        open={openDialog === "NewPassword"}
        user={user}
        fetchUsers={fetchUsers}
        onClose={() => {
          handleDialogClose();
        }}
      />

      { hasAllPermissions(["usr_vw", "usr_vwd"]) && (<IconButton
        size="small"
        aria-label="Info user button"
        onClick={() => handleDialogOpen("UserInfo")}
        style={{
          color: grey[500],
          backgroundColor: alpha(grey[500], 0.1),
        }}
      >
        <Eye variant="Outline" size={20} fontSize="small" />
      </IconButton>)}

      {hasAllPermissions(["usr_per_v", "usr_vw"]) &&
        (isSuperAdmin || isRegionalAdmin) &&
        !isCurrentUser &&
        isAdminUser && (
        <IconButton
          size="small"
          color="primary"
          aria-label="Change user permissions"
          onClick={() => handleDialogOpen("EditPermissions")}
          style={{ color: indigo[400], backgroundColor: alpha(indigo[500], 0.1) }}
        >
          <SecurityUser variant="Outline" size={20} fontSize="small" />
        </IconButton>
      )}

      {hasAllPermissions(["usr_del", "usr_vw"]) && !isCurrentUser && (
        <IconButton
          size="small"
          color="primary"
          aria-label="Delete user button"
          onClick={() => handleDialogOpen("DeleteConfirmation")}
          style={{ color: red[400], backgroundColor: alpha(red[500], 0.1) }}
        >
          <Trash variant="Outline" size={20} fontSize="small" />
        </IconButton>
      )}

      {hasAllPermissions(["usr_chp", "usr_vw"]) && (<IconButton
        size="small"
        color="primary"
        aria-label="Change password button"
        onClick={() => handleDialogOpen("NewPassword")}
        style={{ color: blue[400], backgroundColor: alpha(blue[500], 0.1) }}
      >
        <Key variant="Outline" size={20} fontSize="small" />
      </IconButton>)}
    </Stack>
  );
}
